import appSettings from 'wanderu-config';
import { selectCurrency, selectLocale } from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import { checkAccountExistsAction } from '../..';
import {
    EMAIL_FIELD_ID,
    USER_ACCOUNT_FIELD_IDS,
} from '../../../constants';
import { getFormField } from '../../../utils';
import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:submitForm');

function updateUserInfoAddress(userInfo) {
    const updatedUserInfo = { ...userInfo };
    if (updatedUserInfo[USER_ACCOUNT_FIELD_IDS.streetAddress2] !== undefined) {
        updatedUserInfo[USER_ACCOUNT_FIELD_IDS.streetAddress] = `${updatedUserInfo[USER_ACCOUNT_FIELD_IDS.streetAddress]} ${updatedUserInfo[USER_ACCOUNT_FIELD_IDS.streetAddress2]}`;
    }
    delete updatedUserInfo[USER_ACCOUNT_FIELD_IDS.streetAddress2];

    return updatedUserInfo;
}

function autoFillForm() {
    return (dispatch, getState) => {
        dispatch(actions.reset());
        dispatch(actions.startWork());

        let error;
        let meta;
        try {
            const form = bookingSelectors.selectFormData(getState());
            let userInfo = bookingSelectors.selectUserInfo(getState()) || {};

            if (!userInfo?.[USER_ACCOUNT_FIELD_IDS.country]) {
                dispatch(autoFillCountry());
            }

            if (getFormField(form, USER_ACCOUNT_FIELD_IDS.streetAddress2) === undefined) {
                userInfo = updateUserInfoAddress(userInfo);
            }

            let phoneNumber = userInfo?.[USER_ACCOUNT_FIELD_IDS.phoneNumber];
            if (phoneNumber?.length === 10) { // maybe a phone number saved without a country code
                const locale = selectLocale(getState());
                const [_language, location] = locale.split('-');

                if (['us', 'ca'].includes(location)) { // check if the user is in a country with a +1 country code
                    userInfo[USER_ACCOUNT_FIELD_IDS.phoneNumber] = '1' + phoneNumber;
                }
            }

            const userKeysToUpdate = Object.keys(userInfo).filter((key) => !!userInfo[key]);

            return userKeysToUpdate.forEach((key, index) => {
                const isLastKey = index + 1 === userKeysToUpdate.length;
                const value = userInfo[key];
                const formFieldId = key.split('/').pop();

                dispatch(bookingActions.setFieldValue(key, value, !!isLastKey));

                if (formFieldId === EMAIL_FIELD_ID) {
                    dispatch(checkAccountExistsAction.checkAccountExists(value));
                }
            });
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            error = {
                code: ex.code,
                errorName: ex?.responseBody?.error?.name,
                message: ex.message,
                name: ex.name,
                status: ex?.responseBody?.error?.status,
            };

            logger.warn('autoFillForm', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            return undefined;
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

function autoFillCountry() {
    return (dispatch, getState) => {
        const currency = selectCurrency(getState());

        if (currency === 'USD') {
            return dispatch(bookingActions.setFieldValue(USER_ACCOUNT_FIELD_IDS.country, 'US', false));
        }

        if (currency === 'CAD') {
            return dispatch(bookingActions.setFieldValue(USER_ACCOUNT_FIELD_IDS.country, 'CA', false));
        }

        return undefined;
    };
}

const autoFillFormAction = {
    autoFillForm,
    ...selectors,
};

export {
    autoFillFormAction,
};

const autoFillFormSlice = {
    [namespace]: reducer,
};

export default autoFillFormSlice;
